export function useSeasonalComposable() {
  const formatDurations = (durations?: string[]) => {
    return durations ? durations.join(',') : '';
  };

  const initSeasonalValue = (value) => {
    return value
      ? {
          ...value,
          durations: formatDurations(value.durations)
        }
      : { dayOfWeeks: [1, 1, 1, 1, 1, 1, 1], durations: formatDurations([]), isDefaultSeason: true, startDay: '', startMonth: '', endDay: '', endMonth: '' };
  };

  return { initSeasonalValue, formatDurations };
}
